import {
  DynamicModuleContextDefaultValue,
  DynamicModuleContextI,
  DynamicModulesConfigMap,
  DynamicModuleSlug,
} from './dynamic-modules.types';
import { initGameConfigModule } from './game-config/game-config';
import { initGameRegistryModule } from './game-registry/game-registry';

type DynamicModulesHandlers = {
  [K in DynamicModuleSlug]: (configMap: DynamicModulesConfigMap) => Promise<DynamicModuleContextI[K]>;
};

const dynamicModulesHandlers: DynamicModulesHandlers = {
  [DynamicModuleSlug.GAME_CONFIG]: initGameConfigModule,
  [DynamicModuleSlug.GAME_REGISTRY]: initGameRegistryModule,
};

function setDynamicModuleData<K extends DynamicModuleSlug>(
  target: DynamicModuleContextI,
  key: K,
  value: DynamicModuleContextI[K]
) {
  target[key] = value;
}

export async function initDynamicModules(configMap: DynamicModulesConfigMap): Promise<DynamicModuleContextI> {
  const data: DynamicModuleContextI = { ...DynamicModuleContextDefaultValue };

  await Promise.allSettled(
    Object.values(DynamicModuleSlug).map(async (slug) => {
      setDynamicModuleData(data, slug, await dynamicModulesHandlers[slug](configMap));
    })
  );

  return data;
}
